import { AxiosError } from "axios";
import qs from "query-string";
import { useQuery } from "react-query";
import { ImageIntellGetAllExecutionsResponse } from "../types";
import axiosClient from "../utils/axiosClient";

export const useGetImageIntelExecutions = (
  pageTable: number,
  resultsPerPage: number = 20
) => {
  const newSkip = (pageTable - 1) * resultsPerPage;
  return useQuery<any, AxiosError<any>, ImageIntellGetAllExecutionsResponse>(
    ["imageIntelExecutions", "all", pageTable],
    async () => {
      const query: Record<string, any> = {
        skip: newSkip,
        limit: resultsPerPage,
      };

      const data = await axiosClient.get<ImageIntellGetAllExecutionsResponse>(
        `/image-intell/getPastExecutions?${qs.stringify(query)}`
      );
      return data.data;
    },
    {
      staleTime: Infinity,
      // keepPreviousData: true,
      enabled: false,
    }
  );
};
